import React from 'react';
import { Card, CardBody } from 'reactstrap';

const SettingsPlaceholder = () => (
  <Card>
    <CardBody
      style={{
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
      }}
    >
      <i
        className="now-ui-icons ui-2_settings-90"
        style={{ fontSize: '48px', color: '#9a9a9a', marginBottom: '20px' }}
      />
      <h5>No subject selected</h5>
      <p className="text-muted" style={{ maxWidth: '420px' }}>
        Select a section, then a subject from the left to view and edit its
        settings. Each subject's changes are saved together with Save changes.
      </p>
    </CardBody>
  </Card>
);

export default SettingsPlaceholder;
